import { render, staticRenderFns } from "./CRB65Score.vue?vue&type=template&id=6e3cca0e&scoped=true&"
import script from "./CRB65Score.vue?vue&type=script&lang=js&"
export * from "./CRB65Score.vue?vue&type=script&lang=js&"
import style0 from "./CRB65Score.vue?vue&type=style&index=0&id=6e3cca0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3cca0e",
  null
  
)

export default component.exports